import React from 'react';
import { MAX_NOTE, NOTE_CHIPS, NOTE_FOOTNOTE, noteProblem, toggleChip } from '../lib/riderNote';

// "A note for your chauffeur": a text box (300 characters) and five quick chips, in the same quiet luxury style as the cabin card.
export default function RiderNoteCard({ note, setNote, chips, setChips }) {
  const problem = noteProblem(note);
  const left = MAX_NOTE - String(note || '').length;
  return (
    <div data-testid="rider-note" className="rounded-3xl border border-white/15 bg-white/[0.03] p-6 sm:p-7">
      <label htmlFor="rider-note-input" className="block text-xs tracking-[0.18em] uppercase text-gray-300 mb-2.5">A note for your chauffeur</label>
      <textarea id="rider-note-input" data-testid="rider-note-input" value={note} rows={3} maxLength={MAX_NOTE + 50}
        onChange={(e) => setNote(e.target.value)} aria-describedby="rider-note-help rider-note-error"
        placeholder="Anything that will help, for example where to meet you or what you are carrying"
        className="w-full rounded-2xl bg-white/[0.04] border border-white/15 px-4 py-3 text-base text-gray-50 placeholder-gray-400 focus:border-white/70 focus:outline-none resize-none" />
      <div className="flex justify-between gap-3 mt-1.5 text-sm">
        <span id="rider-note-error" data-testid="rider-note-error" className="text-red-300" role={problem ? 'alert' : undefined}>{problem}</span>
        <span className={left < 0 ? 'text-red-300' : 'text-gray-300'} data-testid="rider-note-count">{String(note || '').length}/{MAX_NOTE}</span>
      </div>
      <div className="flex flex-wrap gap-2.5 mt-4" role="group" aria-label="Quick requests">
        {NOTE_CHIPS.map((c) => {
          const on = (chips || []).includes(c);
          return (
            <button type="button" key={c} aria-pressed={on} data-testid={`note-chip-${c.toLowerCase().replace(/[^a-z]+/g, '-').replace(/-$/, '')}`}
              onClick={() => setChips((cur) => toggleChip(cur, c))}
              className={`min-h-[44px] px-4 rounded-full text-[15px] border transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-white/60 ${on ? 'bg-white/[0.14] border-white/50 text-white' : 'border-white/20 text-gray-200 hover:border-white/40 hover:text-white'}`}>{c}</button>
          );
        })}
      </div>
      <p id="rider-note-help" className="text-sm text-gray-400 mt-4" data-testid="rider-note-footnote">{NOTE_FOOTNOTE}</p>
    </div>
  );
}
